import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";

const AIRecommendation = ({ selectedStudent }) => {
  const [recommendation, setRecommendation] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isGenerated, setIsGenerated] = useState(false);

  // Dummy data for existing recommendation (simulating fetch)
  const dummyRecommendation = `Based on the student's profile:\n- Name: ${selectedStudent.firstName} ${selectedStudent.lastName}\n- Strengths: Strong in academics and extracurriculars.\n- Recommendations: Focus on advanced courses in STEM and leadership roles in school clubs.`;

  // Simulate fetching an existing recommendation
  const fetchRecommendation = () => {
    setIsLoading(true);
    try {
      // Simulate API delay
      setTimeout(() => {
        setRecommendation(dummyRecommendation);
        setIsGenerated(true);
        setIsLoading(false);
      }, 1000);
    } catch (error) {
      console.error("Error fetching dummy recommendation:", error);
      toast.error("Failed to load recommendation.");
      setIsLoading(false);
    }
  };

  // Simulate generating a new recommendation
  const generateRecommendation = () => {
    setIsLoading(true);
    try {
      // Simulate API delay
      setTimeout(() => {
        setRecommendation(dummyRecommendation);
        setIsGenerated(true);
        toast.success("AI Recommendation generated successfully!");
        setIsLoading(false);
      }, 1000);
    } catch (error) {
      console.error("Error generating dummy recommendation:", error);
      toast.error("Failed to generate recommendation.");
      setIsLoading(false);
    }
  };

  // Simulate saving the recommendation
  const saveRecommendation = () => {
    if (!recommendation) {
      toast.error("Please generate or enter a recommendation first.");
      return;
    }
    setIsLoading(true);
    try {
      // Simulate API delay
      setTimeout(() => {
        console.log("Saved Recommendation:", recommendation);
        toast.success("Recommendation saved successfully!");
        setIsLoading(false);
      }, 1000);
    } catch (error) {
      console.error("Error saving dummy recommendation:", error);
      toast.error("Failed to save recommendation.");
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchRecommendation();
  }, [selectedStudent]);

  return (
    <div className="profile-content-area">
      <div className="mb-5">
        <h5 className="mb-0 fw-bold">AI Recommendation</h5>
        <p className="text-muted fs-9">
          View or generate personalized recommendations based on student data.
        </p>
      </div>
      <div className="profile-scrollable-area">
        <div className="row g-3">
          <div className="col-12">
            <div className="card shadow-sm border-0 rounded">
              <div className="card-header bg-brand-light text-secondary fw-bold">
                Student Overview
              </div>
              <div className="card-body">
                <div className="row g-3">
                  <div className="col-md-4">
                    <strong>Name:</strong> {selectedStudent.firstName}{" "}
                    {selectedStudent.lastName}
                  </div>
                  <div className="col-md-4">
                    <strong>Class:</strong> {selectedStudent.className || "N/A"}
                  </div>
                  <div className="col-md-4">
                    <strong>Nationality:</strong>{" "}
                    {selectedStudent.nationality || "N/A"}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h6 className="fw-bold mb-0">AI-Generated Recommendation</h6>
              <button
                className="btn btn-sm btn-primary"
                onClick={generateRecommendation}
                disabled={isLoading}
              >
                {isLoading ? "Generating..." : "Generate Recommendation"}
              </button>
            </div>
            <textarea
              className="form-control"
              rows="10"
              value={recommendation}
              onChange={(e) => setRecommendation(e.target.value)}
              placeholder="AI recommendation will appear here..."
              disabled={!isGenerated || isLoading}
            ></textarea>
            {isGenerated && (
              <small className="text-muted d-block mt-2">
                You can edit the recommendation above before saving.
              </small>
            )}
          </div>
        </div>
      </div>
      <div className="mt-auto">
        <div className="d-flex justify-content-end gap-3">
          <button
            type="button"
            className="btn btn-sm btn-outline-secondary"
            onClick={fetchRecommendation}
            disabled={isLoading}
          >
            Refresh
          </button>
          <button
            type="button"
            className="btn btn-sm btn-primary"
            onClick={saveRecommendation}
            disabled={isLoading || !isGenerated}
          >
            Save Recommendation
          </button>
        </div>
      </div>
    </div>
  );
};

export default AIRecommendation;
